(function () {
  'use strict';

  var MULTISELECT_PLACEHOLDER = (window.dvtGravityForms && window.dvtGravityForms.multiselectPlaceholder) || '';

  /**
   * Initialize Chosen on multiselect fields that GF missed
   * and fix placeholders on fields GF already initialized.
   */
  function initChosenFields() {
    if (typeof jQuery === 'undefined' || typeof jQuery.fn.chosen === 'undefined') {
      return;
    }

    jQuery('.gfield select[multiple]').each(function () {
      var $select = jQuery(this);
      var placeholder = MULTISELECT_PLACEHOLDER;

      if ($select.next('.chosen-container').length) {
        fixChosenPlaceholder($select, placeholder);
        return;
      }

      $select.chosen({
        width: '100%',
        disable_search_threshold: 0,
        placeholder_text_multiple: placeholder,
      });
    });
  }

  /**
   * Update placeholder on an already-initialized Chosen instance.
   */
  function fixChosenPlaceholder($select, placeholder) {
    var chosen = $select.data('chosen');

    if (!chosen) {
      return;
    }

    chosen.default_text = placeholder;

    var $container = $select.next('.chosen-container');
    var $input = $container.find('.search-field input[type="text"]');

    if ($container.find('.search-choice').length > 0) {
      return;
    }

    $input.val(placeholder);
  }

  /**
   * Make file upload drop areas clickable across all forms.
   * Uses event delegation so it works regardless of plupload init state.
   */
  function initFileUploadClicks() {
    document.addEventListener('click', function (e) {
      if (e.target.type === 'file') {
        return;
      }

      var dropArea = e.target.closest('.gform_drop_area');

      if (!dropArea) {
        return;
      }

      if (dropArea.dataset.clicking) {
        return;
      }

      dropArea.dataset.clicking = '1';

      var fileInput = dropArea.querySelector('input[type="file"]');

      if (fileInput) {
        setTimeout(function () {
          fileInput.click();
          setTimeout(function () {
            delete dropArea.dataset.clicking;
          }, 100);
        }, 10);
      }
    });
  }

  /**
   * Populate hidden fields in whitepaper forms from wrapper data attributes.
   * Field input_2 = whitepaper URL, input_3 = whitepaper title.
   */
  function initWhitepaperForms() {
    var wrappers = document.querySelectorAll('.js-whitepaper-form');

    for (var i = 0; i < wrappers.length; i++) {
      var wrapper = wrappers[i];
      var url = wrapper.getAttribute('data-whitepaper-url') || '';
      var title = wrapper.getAttribute('data-whitepaper-title') || '';

      var urlField = wrapper.querySelector('input[name="input_2"]');
      var titleField = wrapper.querySelector('input[name="input_3"]');

      if (urlField) {
        urlField.value = url;
      }

      if (titleField) {
        titleField.value = title;
      }

      var inputs = wrapper.querySelectorAll('input[type="email"], input[type="text"]');
      for (var j = 0; j < inputs.length; j++) {
        if (inputs[j].value === 'Array') {
          inputs[j].value = '';
        }
      }
    }
  }

  function init() {
    initChosenFields();
    initFileUploadClicks();
    initWhitepaperForms();
  }

  if (document.readyState === 'complete') {
    setTimeout(init, 100);
  }

  window.addEventListener('load', function () {
    setTimeout(init, 100);
  });

  if (typeof jQuery !== 'undefined') {
    jQuery(document).on('gform_post_render', function () {
      setTimeout(initChosenFields, 100);
      setTimeout(initWhitepaperForms, 100);
    });

    jQuery(document).on('gform_confirmation_loaded', function (e, formId) {
      var wrapper = document.querySelector('.js-whitepaper-form');

      if (!wrapper) {
        return;
      }

      var formInWrapper = wrapper.querySelector('#gform_confirmation_wrapper_' + formId);

      if (!formInWrapper) {
        return;
      }

      var pdfUrl = wrapper.getAttribute('data-whitepaper-url');

      if (!pdfUrl) {
        return;
      }

      var link = document.createElement('a');
      link.href = pdfUrl;
      link.download = '';
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  }
})();
